import { FC } from "react";
import { Button, Tooltip, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { SvgIcon } from "../../../../../common/components/SvgIcon";
import { Tactic } from "../../../../../types/TacticTypes";
import { DateTime } from "../../../../../common/components/DateTime";
import { ListCard, ListCardField, ListCardTag } from "../../../../../common/components/ListCard";

const { Text } = Typography;

interface RFXCardProps {
    tactic: Tactic;
}

export const RFXCard: FC<RFXCardProps> = ({ tactic }) => {
    const navigate = useNavigate();

    const onClick = () => navigate(`/project/${tactic.projectId}`);

    const fields: ListCardField[] = [
        {
            label: "Name",
            span: 2,
            content: (
                <Text strong ellipsis style={{ fontSize: 14, color: "#1890FF" }}>
                    {tactic.name}
                </Text>
            ),
        },
        {
            label: "Type",
            content: <ListCardTag color="blue">RFX</ListCardTag>,
        },
        {
            label: "Date created",
            content: (
                <ListCardTag color="green">
                    <DateTime date={tactic.recordCreationDate} showTime={false} />
                </ListCardTag>
            ),
        },
    ];

    const actions = (
        <Tooltip title="Open RFX">
            <Button
                type="primary"
                icon={<SvgIcon name="forms" color="#fff" size={14} />}
                onClick={onClick}
            />
        </Tooltip>
    );

    return (
        <ListCard
            style={{ background: "#F2FBFF", borderBottom: "1px solid #C0E1F0" }}
            onClick={onClick}
            logoFallback={tactic.name}
            fields={fields}
            actions={actions}
        />
    );
};
